module.exports = __webpack_public_path__ + "img/logo.eeb78702.png";